/**
 * Retour de scan en très grand pendant 1 s, traversable : vert « +1 » avec le nouveau stock,
 * rouge pour un code inconnu.
 */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '@/lib/utils';

export type FlashInfo = { name: string; stock: number; delta: number } | { unknownCode: string };

const FLASH_MS = 1000;

export function BurstFlash({ info }: { info: FlashInfo | null }) {
  const [shown, setShown] = useState<FlashInfo | null>(null);
  useEffect(() => {
    if (!info) return undefined;
    setShown(info);
    const timer = setTimeout(() => setShown(null), FLASH_MS);
    return () => clearTimeout(timer);
  }, [info]);
  if (!shown) return null;
  const unknown = 'unknownCode' in shown;
  return createPortal(
    <div
      role="status"
      data-testid="burst-flash"
      className={cn(
        'pointer-events-none fixed inset-x-3 top-1/3 z-[60] rounded-2xl p-4 text-center text-white shadow-2xl',
        unknown ? 'bg-red-700' : 'bg-green-700',
      )}
    >
      {unknown ? (
        <>
          <p className="text-2xl font-bold">Code inconnu</p>
          <p className="break-all font-mono text-3xl font-bold">{shown.unknownCode}</p>
          <p className="text-base">Mis de côté, à traiter ensuite</p>
        </>
      ) : (
        <>
          <p className="line-clamp-2 text-lg font-semibold">{shown.name}</p>
          <p className="text-[56px] font-bold leading-none">
            {shown.stock}{' '}
            <span className="text-3xl">({shown.delta > 0 ? `+${shown.delta}` : shown.delta})</span>
          </p>
          <p className="text-base">en stock</p>
        </>
      )}
    </div>,
    document.body,
  );
}
